export const isBeta = () => process.env.APP_ENV === 'beta' || process.env.NODE_ENV !== 'production';

export const isProd = process.env.NODE_ENV === 'production';
export const isNotProd = !isProd;
export const isDev = process.env.NODE_ENV === 'development';

export const isBrowser = typeof window !== 'undefined';
